import ImageSlider from "./ImageSlider";
import { esgSlides } from "../data/esg-slides";

export default function ESGSlider(props) {
  const { slides, ...rest } = props || {};
  return (
    <ImageSlider
      slides={Array.isArray(slides) && slides.length > 0 ? slides : esgSlides}
      containerClass="max-w-6xl mx-auto"
      defaultLayout="split"
      {...rest}
    />
  );
}
